import * as React from 'react';
import * as style from './PromoCompilationItem.css';

export interface IPromoCompilationItemProps {
  /**
   * Элемент иллюстрации для подборки
   * Должен иметь размеры 100% x 100%
   * */
  illustration: React.ReactNode;
  /**
   * Элемент контента для подборки
   * Должен иметь размеры 100% x 100%
   * */
  content: React.ReactNode;
  title: string;
  url: string;
  backgroundColor: string;
  onClick?(): void;
}

export const PromoCompilationItem: React.FC<IPromoCompilationItemProps> = React.forwardRef(
  (props, ref: React.Ref<HTMLAnchorElement>) => {
    const { illustration, content, title, url, backgroundColor, onClick } = props;

    return (
      <a
        ref={ref}
        href={url}
        rel={'noreferrer'}
        target={'_blank'}
        title={title}
        className={style['container']}
        style={{ backgroundColor }}
        onClick={onClick}
      >
        <div className={style['illustration']}>{illustration}</div>
        <div className={style['content']}>{content}</div>
      </a>
    );
  },
);

PromoCompilationItem.displayName = 'PromoCompilationItem';
